export default {"src":"/_next/static/media/globe.af263260.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};